import { useEffect } from 'react';
import { useToast } from '@chikara/ui';
import type { ApiError } from '@chikara/types';
import { t } from '@/i18n';

export function ErrorProvider({ children }: { children: React.ReactNode }) {
  const toast = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const error = (event as CustomEvent<ApiError>).detail;
      const message = error.message || t('errors.unknown');

      const isWarning = error.code === 'MFA_EXPIRED' || error.code === 'LOCATION_REQUIRED';

      if (isWarning) {
        toast.warning(message);
      } else {
        toast.error(message);
      }
    };

    window.addEventListener('api:error', handler);
    return () => window.removeEventListener('api:error', handler);
  }, [toast]);

  return <>{children}</>;
}
